import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// import Lottie from "lottie-react";

import * as successAnimation from "./Success_Modal.json";
import "./Success_Modal.css";
import Lottie from "react-lottie";
import Common_Button from "../../common_button/Common_Button";
import { faPersonWalkingArrowLoopLeft } from "@fortawesome/free-solid-svg-icons";

const Success_Modal = ({ show, onHide }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    onHide();
    navigate("/new/home");
  };

  const successLottieOptions = {
    loop: false,
    autoplay: true,
    animationData: successAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="common_modal success_modal"
      backdrop="static"
    >
      <Modal.Body>
        <div className="success_modal_content">
          <div className="success_lottie">
            <Lottie options={successLottieOptions} />
          </div>

          <h3>Success!</h3>

          <p>
            Your application has been submitted successfully.
            <br />
            Thank you for getting in touch with us.
          </p>

          <Common_Button
            icon={faPersonWalkingArrowLoopLeft}
            text="Continue"
            type="button"
            onClick={handleClose}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Success_Modal;
